import { Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'components/core/theme-provider';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip';

interface VoiceCallButtonProps {
  onClick: () => void;
  disabled?: boolean;
  /** A call is already running; the button glows and stays disabled. */
  isActive?: boolean;
}

export const VoiceCallButton = ({
  onClick,
  disabled = false,
  isActive = false,
}: VoiceCallButtonProps) => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const label = t('VOICE_CALL_START', { defaultValue: 'Start voice call' });
  const iconColor = theme === 'dark' ? 'text-[#ffffff]' : 'text-[#3D3D3D]';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Start voice call button"
            aria-pressed={isActive}
            className={`flex h-7 w-7 min-w-7 shrink-0 items-center justify-center p-0 hover:rounded-full hover:bg-muted disabled:opacity-40 2xl:h-8 2xl:min-w-8 2xl:w-8 ${isActive ? 'rounded-full animate-pulse-glow' : ''}`}
            onClick={onClick}
            disabled={disabled}
          >
            <Phone
              width={20}
              height={20}
              strokeWidth={1.5}
              className={`size-4 shrink-0 2xl:size-5 ${iconColor}`}
            />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
